import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { BreadcrumbNameLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoader";
import { texts } from "../../../../i18n/texts";

@BreadcrumbLoader("/project-table")
export class AdminViewProjectTableBreadcrumbNameLoader extends BreadcrumbNameLoader {
  name = texts.adminView.projectTable;
}
